import React, {lazy} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';

const Home = lazy(() => import('../../../modules/Home'));

export const analyticsConfigs = [
  {
    permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
    path: '/Home',
    element: <Home />,
  },
];
